import { Stack, Typography } from "@mui/material";
import { Progress } from "../Progress";
import { AnalyticItem } from "../AnalyticItem";
import { AnalyticCardWrapper } from "../AnalyticCardWrapper";
import { ReactNode } from "react";
import { RateIndicator } from "../../../../types/enums";

export const AccountsDiscoveryRate = ({
  total_rate,
  your_data,
  external_data,
  children,
  external_data_indicator,
  external_data_change,
  external_data_changed_at,
  your_data_indicator,
  your_data_changed_at,
  your_data_change,
}: {
  total_rate: number;
  your_data: number;
  external_data: number;
  external_data_indicator?: RateIndicator;
  children?: ReactNode;
  external_data_changed_at?: string | undefined;
  external_data_change?: number | undefined;
  your_data_indicator?: RateIndicator;
  your_data_changed_at?: string;
  your_data_change?: number;
}) => {
  return (
    <AnalyticCardWrapper
      title="Members Identified"
      tooltip="Rate of total discovered BC members in available data, relative to the total number of
       BC expected for analyzed accounts."
    >
      {children}
      <Stack
        gap="20px"
        flexGrow={1}
        minWidth="300px"
        justifyContent="space-between"
      >
        <Stack gap="54px" direction="row">
          <Stack>
            <Typography variant="h2" color="#051123" sx={{ fontSize: "32px" }}>
              {total_rate ?? 0}%
            </Typography>
            <Typography variant="body1" color="#051123">
              of all expected members
            </Typography>
          </Stack>
          <Stack gap="16px" direction="row">
            <AnalyticItem
              title="Your Data"
              percentage={your_data}
              color="#1B3967"
              indicatorRate={your_data_indicator}
              indicatorChange={your_data_change}
              indicatorChangeAt={your_data_changed_at}
            />
            <AnalyticItem
              title="INFUSE Data Extension"
              percentage={external_data}
              color="#FE8836"
              indicatorRate={external_data_indicator}
              indicatorChange={external_data_change}
              indicatorChangeAt={external_data_changed_at}
            />
          </Stack>
        </Stack>
        <Progress primaryValue={your_data} secondaryValue={external_data} />
      </Stack>
    </AnalyticCardWrapper>
  );
};
